import fetch from 'isomorphic-fetch';
import queryString from 'query-string';

import config from '../config';

const HOUSEHOLD_TIMEOUT = 10 * 1000;

export const tierTypeIds = {
    NONE: 0,
    CORE: 1,
    PREFERRED: 2,
    SELECT: 3,
    PERSONAL_SERVICE: 4,
    ENHANCED_PERSONAL_SERVICE: 5
};

const openTiers = [
    tierTypeIds.SELECT,
    tierTypeIds.PERSONAL_SERVICE,
    tierTypeIds.ENHANCED_PERSONAL_SERVICE
];

const iclassTiers = [
    tierTypeIds.PERSONAL_SERVICE,
    tierTypeIds.ENHANCED_PERSONAL_SERVICE
];

export const getOpenTier = (summitTier) => openTiers.includes(summitTier);
export const getIClassTier = (summitTier) => iclassTiers.includes(summitTier);

export const helpers = {};

helpers.getParsedQS = () => queryString.parse(window.location.search);

helpers.callSvc = async () => {
    try {
        const url = `${config(
            'apiDomain',
            'https://apidev.awstrp.net'
        )}/nasu-svc/service/household`;

        const res = await fetch(url, {
            // @TODO should be changed to get once GLI is back online
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Access-Control-Allow-Credentials': true,
                'X-TRP-Requested-With': 'XMLHttpRequest',
                'X-Frame-Options': 'SAMEORIGIN',
                'X-Content-Type-Options': 'nosniff',
                'X-XSS-Protection': 1,
                apikey: config('apiKey'),
                'Strict-Transport-Security':
                    'max-age=31536000; includeSubDomains'
            }
            // body: JSON.stringify({ businessPartnerId: 1766655 })
        });

        if (res.status === 200) {
            const json = await res.json();
            const {
                householdBalanceTierStatus: {
                    householdAssetTier: { id }
                }
            } = json;
            return id;
        }
        return tierTypeIds.NONE;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('uh oh error: ', err);
        return tierTypeIds.NONE;
    }
};

helpers.timeout = () =>
    new Promise((res) => setTimeout(res, HOUSEHOLD_TIMEOUT, tierTypeIds.NONE));

export const getSummitTier = async (...args) =>
    Promise.race([helpers.callSvc(...args), helpers.timeout()]);



// WEBPACK FOOTER //
// ./src/summit-program/summit.js